import { render, staticRenderFns } from "./AddArtist.vue?vue&type=template&id=4ae69a60&scoped=true&"
import script from "./AddArtist.vue?vue&type=script&lang=js&"
export * from "./AddArtist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ae69a60",
  null
  
)

export default component.exports